import { Box, Text, chakra } from "@chakra-ui/react";

const FormContainer = chakra(Box, {
  baseStyle: {
    width: { base: "full", md: "520px" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "10px",
  },
});
const ForgotPasswordTopHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "700",
    fontSize: { base: "24px", md: "28.42px" },
    marginTop: { base: "24px", md: "32px" },
    textAlign: "center",
  },
});
const ForgotPasswordHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "32px" },
    marginTop: { base: "24px", md: "16px" },
    textAlign: "center",
  },
});
const ForgotPasswordSubHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "16px" },
    textAlign: "center",
    color: "primary.grayText",
    marginTop: "16px",
  },
});

const ForgotPasswordForm = chakra("form", {
  baseStyle: {
    width: "100%",
  },
});

export {
  FormContainer,
  ForgotPasswordTopHeading,
  ForgotPasswordHeading,
  ForgotPasswordSubHeading,
  ForgotPasswordForm,
};
